<template>
  <li>
    <div class="flex items-center space-x-4">
      <div class="shrink-0">
        <BaseLogo
          :entity="user"
          logo-key="attributes.avatar"
        />
      </div>
      <div class="flex-1 min-w-0">
        <p class="font-bold text-gray-700 truncate">
          {{ user?.attributes?.name  || user?.attributes?.email }}
          <UserRoleBadge
              :user="user"
            />
        </p>
      </div>
      
      <BaseDropdown
        :options="userOptions"
        :label="$t('Options')"
        trigger="hover"
        button-size="sm"
        divide-items
      />

    </div>
  </li>
</template>
<script lang="ts" setup>
import i18n from '@/i18n';
import { computed, PropType } from 'vue'
import actionsEnum from "@/modules/common/enum/actionsEnum";
import Data = API.Data;
import User = App.Domains.Users.Models.User;

const props = defineProps({
  user: {
    type: Object as PropType<Data<User>>,
    default: () => ({})
  },
})

const emit = defineEmits(['remove'])

const userOptions = computed(() => {
  return [
    {
      label: i18n.t('Remove'),
      requiresPermissionTo: actionsEnum.REMOVE_PEOPLE_FROM_ANY_GROUP,
      action: () => {
        emit('remove', props.user)
      },
    }
  ]
})
</script>
